import { Circles, ThreeDots } from "react-loader-spinner";

const LoaderSpinner = ({ bool }) => {
    return (
        <div className="flex justify-center w-100"
            style={{ visibility: bool === true ? 'visible' : 'hidden' }}>
            <div className="bg-blue-100 w-min p-3 rounded-4">
                <ThreeDots
                    visible={true}
                    height={50}
                    width={50}
                    color="#0049a8"
                    radius={9}
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
            </div>

        </div>
    );
};

export default LoaderSpinner